import React from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { ZOOM_LEVEL_LIST } from "../../constants/Constants";
import ZoomService from "../../services/zoomService";
import useLanguageChange from "../../hooks/useLanguageChange";

const zoomLevels = [
    { level: ZOOM_LEVEL_LIST.THREE, label: "3x" },
    { level: ZOOM_LEVEL_LIST.TWO, label: "2x" },
    { level: ZOOM_LEVEL_LIST.ONE, label: "1x" },
];

const zoomStatus = "1";
const isManual = true;

const ZoomLevelButton = () => {
    const { currentZoom } = useSelector((state) => state.commonReducer);
    /* custome hook for getting updated localized value object for entire project 
    This will give localize value object for selected language
    Also will give updated localized value object when language change */
    const localisedValues = useLanguageChange();

    const handleClick = (zoomLevel) => {
        if (currentZoom !== zoomLevel) {
            ZoomService.toggleZoomHandler(zoomLevel, zoomStatus, isManual);
        }
    };

    return (
        <div className='video-zoom-level' data-testid='zoom-button'>
            <div className='zoom-level-text'>{localisedValues?.zoom_level}</div>
            <div className='zoom-level-menu'>
                {zoomLevels?.map(({ level, label }) => (
                    <div className='button' key={level}>
                        <button
                            className={clsx("btn zoom-level-btn", currentZoom == level && "active")}
                            disabled={currentZoom == level}
                            onClick={() => handleClick(level)}
                        >
                            <span className='for-icon'>{label}</span>
                        </button>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ZoomLevelButton;
